import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import PropTypes from "prop-types"
const CardTiketsOverview = ({ title , number , blColor }) => {
    return (
           <Card>
  <Card.Body
    className="h-100 card-body-custom"
    style={{ borderLeft: '8px solid ' + blColor }}
  >
    <Row>
      <Col>{title}</Col>
    </Row>
    <Row>
      <Col>
        <p>
          <span style={{ fontSize: "2em", color: "black" }}>{"$ "+number}</span>
        </p>
      </Col>
      <Col>{''}</Col>
    </Row>
  </Card.Body>
</Card>

    );
}

CardTiketsOverview.propTypes = {
    title: PropTypes.string,
    number: PropTypes.string,
  //  icon: PropTypes.func,
    blColor: PropTypes.string,
}

export default CardTiketsOverview;